import type { PartialReadonlyRecord } from '../../../utils'

export const mapSearch = (search: string | null): PartialReadonlyRecord<'searchText', string> =>
    /**
     * The backend supports regex pattern matching
     * However, it does not support all patterns and will throw errors depending on the sent string
     *
     * This replacement disables any pattern matching that a user may inadvertently activate
     * by turning non word characters into escaped chars
     */
    search ? { searchText: search.replaceAll(/\W{1,1}/g, (match) => `\\${match}`) } : {}
